import classNames from 'clsx';
import { ReactComponent as IconClose } from 'mrg-icons/src/mailru/actions/close_big.svg';
import React, { memo, ReactElement, ReactNode, useCallback, useState } from 'react';
import { Portal } from 'react-portal';
import { CSSTransition } from 'react-transition-group';

import styles from './LeftDialog.css';

interface Props {
    onClose: () => void;
    children: ReactNode;
    mode?: string;
}

const TRANSITION_TIMEOUT = 250;

export const LeftDialog = memo(({ onClose, children, mode }: Props): ReactElement => {
    const [visible, setVisible] = useState<boolean>(true);

    const handleClose = useCallback((): void => {
        setVisible(false);
        if (onClose) {
            setTimeout(onClose, TRANSITION_TIMEOUT);
        }
    }, [onClose]);

    return (
        <Portal>
            <CSSTransition
                in={visible}
                timeout={TRANSITION_TIMEOUT}
                appear
                classNames={{
                    exit: styles.animation_exit,
                    exitActive: styles.animation_exit_active,
                    enter: styles.animation_appear,
                    enterActive: styles.animation_appear_active,
                    appear: styles.animation_appear,
                    appearActive: styles.animation_appear_active,
                }}
            >
                <div
                    className={classNames(styles.root, {
                        [styles[`root_${mode}`]]: !!mode,
                    })}
                >
                    <div className={styles.close} onClick={handleClose}>
                        <IconClose width={14} height={14} fill="currentColor" />
                    </div>
                    {children}
                </div>
            </CSSTransition>
        </Portal>
    );
});

LeftDialog.displayName = 'LeftDialog';
